import React from 'react';
import logout from '../../includes/img/logout.svg';
import { Navbar, Nav, NavItem, Button, Image, NavDropdown, MenuItem, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { USER } from '../containers/User/routes';
import { PRODUCTCLASS } from '../containers/ProductClass/routes';
import { PRODUCT } from '../containers/Product/routes';
import { BUSINESS_PARTNER } from '../containers/BusinessPartner/routes';
import { PROPOSALS } from '../containers/Proposal/routes';
import { ORDER_PATTERN } from '../containers/OrderPattern/routes';
import { ORDER } from '../containers/BPOrder/routes';
import { CONTACT } from '../containers/Contact/routes';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../../includes/custom/css/header.css';
import { EMPTY_COUNT } from '../../utils/constants';
import logo from '../../includes/img/KOS-logo.png';
import pdf from '../../includes/pdf/manual.pdf';

const MainHeader = (props) => {

    const redirectTo = (path) => {
        props.history.push(path)
    }

    const name_tooltip = (
        <Tooltip id="tooltip">
          {props.user.user_nm}
        </Tooltip>
      );

    const DEFAULT_BUTTON = "header-button";
    const ACTIVE_BUTTON = "header-button-active";
    const DEFAULT_DROPDOWN = "basic-nav-dropdown";
    const ACTIVE_DROPDOWN = "basic-nav-dropdown-active";

    return (
        <Navbar inverse collapseOnSelect className="header-green">
            <Navbar.Header className="header-base">
                <Image src={logo} alt={"System Logo"} className="logo-main" />
                <Navbar.Toggle />
            </Navbar.Header>

            <Navbar.Collapse className="nav-collapse">
                <Nav className="header-group">

                    <NavItem componentClass={Link} href={ORDER} to={ORDER}>
                        <Button className={
                             EMPTY_COUNT <= props.location.pathname.indexOf(ORDER)
                              ? ACTIVE_BUTTON : DEFAULT_BUTTON}>受注</Button>
                    </NavItem>

                    <NavItem componentClass={Link} href={PROPOSALS} to={PROPOSALS}>
                        <Button className={EMPTY_COUNT <= props.location.pathname.indexOf(PROPOSALS) ? ACTIVE_BUTTON : DEFAULT_BUTTON}>商品提案</Button>
                    </NavItem>

                    <NavDropdown
                        title="マスタ"
                        className="header-dropdown"
                        id={
                            EMPTY_COUNT <= props.location.pathname.indexOf(USER)
                                || EMPTY_COUNT <= props.location.pathname.indexOf(PRODUCTCLASS)
                                || EMPTY_COUNT <= props.location.pathname.indexOf(PRODUCT)
                                || EMPTY_COUNT <= props.location.pathname.indexOf(BUSINESS_PARTNER)
                                || EMPTY_COUNT <= props.location.pathname.indexOf(ORDER_PATTERN)
                                ? ACTIVE_DROPDOWN : DEFAULT_DROPDOWN
                        }
                    >
                        <MenuItem onClick={() => redirectTo(USER)}>ユーザ</MenuItem>
                        <MenuItem onClick={() => redirectTo(PRODUCTCLASS)}>商品分類</MenuItem>
                        <MenuItem onClick={() => redirectTo(PRODUCT)}>商品</MenuItem>
                        <MenuItem onClick={() => redirectTo(BUSINESS_PARTNER)}>取引先</MenuItem>
                        <MenuItem onClick={() => redirectTo(ORDER_PATTERN)}>発注制御パターン</MenuItem>
                    </NavDropdown>

                    <NavItem componentClass={Link} href={CONTACT} to={CONTACT}>
                        <Button className={EMPTY_COUNT <= props.location.pathname.indexOf(CONTACT) ? ACTIVE_BUTTON : DEFAULT_BUTTON}>連絡</Button>
                    </NavItem>

                </Nav>
                <Nav pullRight className="right-nav">
                    <li role="presentation" className="header-content">
                        <OverlayTrigger placement="bottom" overlay={name_tooltip}>
                            <Link to={"#"}>
                                {props.user.user_nm}
                            </Link>
                        </OverlayTrigger>
                    </li>

                    <NavItem href={pdf} target="_blank">  
                        <FontAwesomeIcon className="header-icons" icon="book" />
                    </NavItem>
                    <NavItem onClick={props.toggleConfirmation.bind(this, true)} className="header-icons header-logout">
                        <Image src={logout} alt="logout-icon" width={50} className="icon-height" />
                    </NavItem>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default MainHeader;